import React from 'react';
import classNames from 'classnames';
import cls from './ModalBodyShowManagerInfo.module.css';
import { useModalBodyShowManagerInfo } from './useModalBodyShowManagerInfo';
import { ManagerInformation } from '../../../types/dashboardInformation';
import { NotGivenRow } from '../../../Blocks/InformationBlock/UI/NotGivenRow/NotGivenRow';

interface ModalBodyShowManagerInfoProps {
    classes?: string;
    managerInfo: ManagerInformation;
}

export const ModalBodyShowManagerInfo = ({
    classes,
    managerInfo,
}: ModalBodyShowManagerInfoProps) => {
    const {} = useModalBodyShowManagerInfo();
    return (
        <div className={classNames(cls.ModalBodyShowManagerInfo, [classes])}>
            <div className={cls.ManagerInfo}>
                <div className={cls.container}>
                    <div className={cls.ImageBlock}>
                        {managerInfo.preview_url ? (
                            <img src={managerInfo.preview_url} alt={managerInfo.position} />
                        ) : (
                            <svg
                                width="80"
                                height="80"
                                viewBox="0 0 80 80"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect width="80" height="80" rx="40" fill="#F4F4F8" />
                                <g clipPath="url(#clip0_1390_49703)">
                                    <path
                                        d="M40 21.25C35.1171 21.25 31.1111 25.256 31.1111 30.1389C31.1111 35.0218 35.1171 39.0278 40 39.0278C44.8829 39.0278 48.8889 35.0218 48.8889 30.1389C48.8889 25.256 44.8829 21.25 40 21.25ZM40 25.6944C42.4809 25.6944 44.4444 27.658 44.4444 30.1389C44.4444 32.6198 42.4809 34.5833 40 34.5833C37.5191 34.5833 35.5556 32.6198 35.5556 30.1389C35.5556 27.658 37.5191 25.6944 40 25.6944ZM40 42.3611C36.1223 42.3611 31.527 43.2717 27.6649 44.796C25.7339 45.5581 23.9882 46.4634 22.5911 47.6259C21.1941 48.7883 20 50.3597 20 52.3611V57.9167H60V55.6945V52.3611C60 50.3597 58.8059 48.7883 57.4089 47.6259C56.0118 46.4634 54.2661 45.5581 52.3351 44.796C48.473 43.2717 43.8777 42.3611 40 42.3611ZM40 46.8056C43.1423 46.8056 47.4357 47.6367 50.7075 48.928C52.3434 49.5736 53.7266 50.3433 54.566 51.0417C55.4054 51.7401 55.5556 52.2158 55.5556 52.3611V53.4722H24.4444V52.3611C24.4444 52.2158 24.5946 51.7401 25.434 51.0417C26.2734 50.3433 27.6566 49.5736 29.2925 48.928C32.5643 47.6367 36.8577 46.8056 40 46.8056Z"
                                        fill="#C1C4C9"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1390_49703">
                                        <rect
                                            width="40"
                                            height="40"
                                            fill="white"
                                            transform="translate(20 20)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        )}
                    </div>
                    <div className={cls.ManagerNameBlock}>
                        <span className={cls.ManagerName}>{managerInfo.full_name}</span>
                        <span className={cls.ManagerPost}>{managerInfo.position}</span>
                    </div>
                </div>

                <div className={cls.CommunicationMethods}>
                    <div className={cls.CommunicationBlock}>
                        <span className={cls.Label}>
                            {i18next.t('ModalBodyShowManagerInfo.return.label.email')}
                        </span>
                        <span className={cls.CommunicationValue}>{managerInfo.email}</span>
                    </div>
                    <div className={cls.CommunicationBlock}>
                        <span className={cls.Label}>
                            {i18next.t('ModalBodyShowManagerInfo.return.label.phone')}
                        </span>
                        {managerInfo.phone === '' ? (
                            <NotGivenRow />
                        ) : (
                            <span className={cls.CommunicationValue}>{managerInfo.phone}</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
